export const TLCEXTJQuery = {
  extend: $.extend,
  innerShiv: (function () {
    function h(c, e, b) {
      return /^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(b)
        ? c
        : e + "></" + b + ">";
    }

    var c,
      e = document,
      j,
      g =
        "abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(
          " "
        );
    return function (d, i) {
      if (
        !c &&
        ((c = e.createElement("div")),
        (c.innerHTML = "<nav></nav>"),
        (j = c.childNodes.length !== 1))
      ) {
        for (var b = e.createDocumentFragment(), f = g.length; f--; )
          b.createElement(g[f]);
        b.appendChild(c);
      }
      d = d
        .replace(/^\s\s*/, "")
        .replace(/\s\s*$/, "")
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
        .replace(/(<([\w:]+)[^>]*?)\/>/g, h);
      c.innerHTML = (b = d.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))
        ? "<table>" + d + "</table>"
        : d;
      b = b ? c.getElementsByTagName(b[1])[0].parentNode : c;
      if (i === !1) return b.childNodes;
      for (var f = e.createDocumentFragment(), k = b.childNodes.length; k--; )
        f.appendChild(b.firstChild);
      return f;
    };
  })(),
  empty: function (ele) {
    var $ele = TLCEXTJQuery._getElementFromString(ele);
    $ele.empty();
  },
  prepend: function (ele, newHTML) {
    var $ele = TLCEXTJQuery._getElementFromString(ele);
    $ele.prepend(TLCEXTJQuery.innerShiv(newHTML));
  },
  append: function (ele, newHTML) {
    var $ele = TLCEXTJQuery._getElementFromString(ele);
    $ele.append(TLCEXTJQuery.innerShiv(newHTML));
  },
  _getElementFromString: function (ele) {
    if (typeof ele === "string") {
      ele = ele.substring(0, 1) == "#" ? ele : "#" + ele;
    }

    return $(ele);
  },
};
